import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { useAuth } from "@/context/auth";

export default function PrivateRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const { tenant } = useParams<{ tenant: string }>();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`/${tenant}/login`}
        replace
        state={{ from: location, needsAuth: true }}
      />
    );
  }

  return <Outlet />;
}
